import { injectable } from "inversify";
import { INavigationService } from "./INavigationService";

@injectable()
export default class NavigationService implements INavigationService {
    public redirectTo(url: string): void {
        var encodedUrl = encodeURI(url);
        window.location.href = encodedUrl;
    }

    public openNewTab(url: string): void {
        var encodedUrl = encodeURI(url);
        window.open(encodedUrl, '_blank');
    }

    public getFragmentValue(key: string): string | undefined {
        const hash = window.location.hash;
        if (hash.length <= 1) {
            return undefined;
        }

        const fragment = hash.startsWith("#") ? hash.substring(1) : hash; // remove '#'
        const params = new URLSearchParams(fragment);
        
        // NOTE: The tokens are currently BASE64-encoded strings that contain '+' characters.
        // However, during URL fragment transmission, '+' characters may be replaced with spaces.
        // Therefore, we need to replace spaces back to '+' before using the tokens.
        // This is a workaround for URL encoding issues. We should really use Base64URL encoding for tokens to avoid such issues.
        return params.get(key)?.replace(/ /g, '+');
    }

    public removeFragment(key: string): void {
        const hash = window.location.hash;
        if (hash.length <= 1) {
            return;
        }

        const fragment = hash.startsWith("#") ? hash.substring(1) : hash; // remove '#'
        const params = new URLSearchParams(fragment);
        params.delete(key);

        const newHash = params.toString();
        const newUrl = window.location.pathname + window.location.search + (newHash ? `#${newHash}` : '');
        window.history.replaceState(null, '', newUrl);
    }
}